import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_frozen from "@amcharts/amcharts4/themes/frozen";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { any } from "@amcharts/amcharts4/.internal/core/utils/Array";
import moment from "moment";
import { AppsService } from "src/app/shared/services/apps.service";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import { Router } from "@angular/router";
import { differenceInCalendarDays } from "date-fns";
import * as L from "leaflet";

// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeExcelCell } from "src/app/shared/utils/sanitize-export";
import "src/app/shared/utils/jspdf-autotable";
import { jsPDF } from "jspdf";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_frozen);
am4core.useTheme(am4themes_animated);
// Themes end
@Component({
  selector: "app-urban-dashboard",
  templateUrl: "./urban-dashboard.component.html",
  styleUrls: ["./urban-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UrbanDashboardComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  /** Stable bound reference for <app-data-grid [cellPrepared]>. */
  bound_onCellPrepared = (e: any) =>
    this.onCellPrepared(this.ulbTripscolumnDefs, e);

  // Subject for unsubscribing from observables on component destroy
  private destroy$ = new Subject<void>();

  // Auto-refresh interval for Vehicle Live Status (10 seconds)
  private vehicleLiveStatusInterval: any;

  header_label = {
    name: "State Dashboard",
    dtepkrlbl: true,
  };

  chart: am4charts.XYChart;
  chart2: am4charts.XYChart;
  chart3: am4charts.XYChart;
  chart4: am4charts.XYChart; // Weekly Distance Chart
  chart5: am4charts.XYChart; // Weekly Operational Status Chart
  distancePieChart: am4charts.PieChart; // Distance Pie Chart
  workingHoursPieChart: am4charts.PieChart; // Working Hours Pie Chart
  ulbTripsDta: any;
  tpPrfmnceUlbDta: any;
  lstPrfmnceUlbDta: any;
  dateFormat = "dd/MM/yyyy";
  ulblable;
  ulbTripscolumnDefs;
  tpPrfmnceUlbcolumnDefs;
  lstPrfmnceUlbcolumnDefs;
  slctdDt = new Date();
  today = new Date();
  curDate;
  curTblDate;
  ttlDstncCnt: any;
  ttlTrpsCnt: any;
  prmryTrpsCnt: any;
  scndryTrpsCnt: any;
  showLdr = false;
  postslctdDt;
  ctgryWseCnts: any;
  // legend: am4charts.Legend;
  curTmspDate: string;
  clntDtls: any;
  chartHeatData = [];
  heatChrt: any;
  curYr: any;
  shwzrwErr: boolean = false;
  shwScndryzrwErr: boolean = false;
  tdyCoveredTrips: any = [];
  ThrtyKmbelowVehcles: any = [];
  ThrtyKmbelowVehclescolumnDefs: any = [];
  ulbwseopratedTripsTble: any;
  ulbwseopratedTripsTblecolumnDefs: any = [];
  ulbVndrwseopratedTripsTble: any;
  ulbVndrwseopratedTripsTblecolumnDefs: any = [];
  ispagination: boolean = false;
  ispagination2: boolean = false;
  ispagination1: boolean = false;
  crdOne: boolean = true;
  crdTwo: boolean = false;
  crdThree: boolean = false;
  crdFour: boolean = false;

  // Overall Vehicle Owner Type counts
  overallOwnerCounts: any = {
    own: 0,
    contract: 0,
    sac: 0,
  };

  // Vehicle Owner Type expansion - Primary
  isPrimaryOwnerExpanded: boolean = false;
  primaryOwnerCounts: any = {
    own: 0,
    contract: 0,
    sac: 0,
  };

  // Vehicle Owner Type expansion - Secondary
  isSecondaryOwnerExpanded: boolean = false;
  secondaryOwnerCounts: any = {
    own: 0,
    contract: 0,
    sac: 0,
  };

  urbn_in: number;
  chartsData: any;
  userDtls: any;
  clap_in: any;
  ShowClap: boolean = false;
  dbrd_ky = "urban";
  smryClmns: any[];
  tntLst: any[] = [];

  // Map and view properties
  currentView: "table" | "map" = "table";
  map: L.Map;
  markers: L.Marker[] = [];
  markerLayer: L.LayerGroup;
  boundaryLayer: L.LayerGroup;
  hoveredTenantData: any = null;
  selectedUlbData: any = null;
  selectedUlbIndex: number = 0;

  // ULB list search filter
  ulbSearchText: string = "";
  filteredUlbList: any[] = [];

  // Vehicle status counts
  vehicleStatusCounts: any = {
    total: 0,
    online: 0,
    offline: 0,
    repair: 0,
    others: 0,
  };

  // Working hours data
  workingHoursData: any = {
    vehicles30Min: 0,
    vehiclesMore30Min: 0,
  };

  // Coverage data
  coverageData: any = {
    coverage: 0,
    coveragePercent: 0,
  };

  // Vehicle status cards data
  vehicleStatusData: any[] = [];

  // Status cards data (like ams-vehicles)
  cardcntSummary: any[] = [];
  asrt_sts_id: any;

  // Fuel card data (using fuel summary structure) - Current Month
  fuelCardData: any = {
    totalUlbsFilled: 0,
    totalUlbsNotFilled: 0,
    totalLitres: 0,
    totalAmount: 0,
    totalEntries: 0,
    vehiclesCount: 0,
    diesel: { count: 0, litres: 0, amount: 0 },
    petrol: { count: 0, litres: 0, amount: 0 },
    cng: { count: 0, kg: 0, amount: 0 },
    // Mileage variance - estimated mileage > actual distance
    mileageVarianceCount: 0,
  };

  // Fuel card data - Previous Month
  prevMonthFuelData: any = {
    totalUlbsFilled: 0,
    totalUlbsNotFilled: 0,
    totalLitres: 0,
    totalAmount: 0,
    totalEntries: 0,
    vehiclesCount: 0,
    diesel: { count: 0, litres: 0, amount: 0 },
    petrol: { count: 0, litres: 0, amount: 0 },
    cng: { count: 0, kg: 0, amount: 0 },
  };

  // Current and previous month labels
  currentMonthLabel: string = "";
  previousMonthLabel: string = "";

  // Dream step maintained data (IMEI starting with 35151)
  dreamStepData: any = {
    count: 0,
  };

  // VMU Maintained data (CDMA and ULB sections)
  vmuMaintainedData: any = {
    cdma: {
      total: 0,
      operated: 0,
      notOperated: 0,
      operatedPercent: 0,
    },
    ulb: {
      total: 0,
      operated: 0,
      notOperated: 0,
      operatedPercent: 0,
    },
  };

  // Live running and parked vehicle counts
  liveVehicleCounts: any = {
    running: 0,
    parked: 0,
  };

  // Vehicle Live Status data
  vehicleLiveStatus: any = {
    total: 0,
    online: 0,
    running: 0,
    offline: 0,
    parked: 0,
    repair: 0,
    standby24hr: 0,
    onlineStandby24hr: 0, // Online vehicles in standby mode for 24 hrs
    offline24hr: 0, // Vehicles offline for more than 24 hrs
    others: 0,
  };

  // Driver Type Counts data (OWN/APCOS/CONTRACT) with attended/not attended
  driverTypeCounts: any = {
    total: 0,
    own: 0,
    apcos: 0,
    contract: 0,
    own_attended: 0,
    own_not_attended: 0,
    apcos_attended: 0,
    apcos_not_attended: 0,
    contract_attended: 0,
    contract_not_attended: 0,
  };

  // Top 10 operated ULBs data
  top10OperatedUlbs: any[] = [];
  top10OperatedUlbsColumnDefs: any[] = [];

  // Least 10 operated ULBs data
  least10OperatedUlbs: any[] = [];

  // Flip card state for Top/Least ULBs
  isUlbCardFlipped: boolean = false;

  // Fuel last 7 days data for graph
  fuelLast7DaysData: any[] = [];
  chart6: am4charts.XYChart;

  // Number formatters for Indian locale
  currencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  numberFormatter = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  // tslint:disable-next-line:no-shadowed-variable
  constructor(
    public apiServ: AppsService,
    public TransfereService: TransfereService,
    public route: Router
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.tntLst = this.clntDtls[0].tnts;
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
    }
  }
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };

  onChange(e): void {
    // console.log('onChange: ',e);
    this.slctdDt = e;
    // console.log('slctdDt: ', this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTblDate = moment(this.slctdDt).format("DD-MM-YYYY");
    // console.log(this.curDate);
    this.get_totalDistanceCount(this.slctdDt);
    this.get_totalTripsCount(this.slctdDt);
    this.get_prmryTripsCount(this.slctdDt);
    this.get_scndryTripsCount(this.slctdDt);
    // this.get_lst7DaysTrpsDta(this.slctdDt);
    // this.get_lst7DaysDistanceDta(this.slctdDt);
    this.get_ctgrywisecounts(this.slctdDt);
    this.get_ulbWsedta(this.slctdDt);
    this.get_today_Ulb_CoveredTripsCount(this.slctdDt, 0);
    this.getOverallOwnerCounts();
    this.getPrimaryOwnerCounts();
    this.getSecondaryOwnerCounts();
    this.getbelowThirtyKmVehicles(this.slctdDt);
    this.getVehiclesOperatedcntsULBwise(this.slctdDt);
    this.getVehiclesOperatedcntsVndrULBwise(this.slctdDt);
    this.getVehicleStatusData();
    this.getStatusCardsData();
    this.getWorkingHoursData();
    this.getCoverageData();

    // Reload weekly charts
    this.getWeeklyDistanceData();
    this.getWeeklyOperationalStatusData();

    // Reload fuel and dream step data
    this.getFuelCardData();
    this.getDreamStepData();

    // Reload live vehicle counts and top 10 ULBs
    // this.getLiveVehicleCounts();
    this.getVehicleLiveStatus();
    this.getVmuMaintainedData();
    this.getDriverTypeCounts();
    // this.getTop10OperatedUlbs();

    // Reload fuel last 7 days graph
    this.getFuelLast7DaysData();
  }

  ngOnInit() {
    this.curYr = moment(this.today).format("YYYY");
    // console.log('Current Year ******************************************* ',this.curYr);
    this.slctdDt = new Date();
    this.curTblDate = moment(this.slctdDt).format("DD-MM-YYYY");
    this.get_totalDistanceCount(this.slctdDt);
    this.get_totalTripsCount(this.slctdDt);
    this.get_prmryTripsCount(this.slctdDt);
    this.get_scndryTripsCount(this.slctdDt);
    // this.get_lst7DaysTrpsDta(this.slctdDt);
    // this.get_lst7DaysDistanceDta(this.slctdDt);
    this.get_ctgrywisecounts(this.slctdDt);
    this.get_ulbWsedta(this.slctdDt);
    this.get_today_Ulb_CoveredTripsCount(this.slctdDt, 0);
    this.getbelowThirtyKmVehicles(this.slctdDt);
    this.getVehiclesOperatedcntsULBwise(this.slctdDt);
    this.getVehiclesOperatedcntsVndrULBwise(this.slctdDt);

    // this.chart = am4core.create('tripsTrackedChart', am4charts.XYChart);

    // function create1Series(value, name) {
    //   let series = this.chart.series.push(new am4charts.ColumnSeries())
    //   series.dataFields.valueY = value
    //   series.dataFields.categoryX = 'c'
    //   series.name = name

    //   let bullet = series.bullets.push(new am4charts.LabelBullet())
    //   bullet.interactionsEnabled = false
    //   bullet.dy = 30;
    //   bullet.label.text = '{valueY}'
    //   bullet.label.fill = am4core.color('#ffffff')

    //   return series;
    // }
    // Add data
    this.getChrtsData(1);
    this.cardOne();

    // Load working hours and coverage data
    this.getWorkingHoursData();
    this.getCoverageData();

    // Load vehicle status data
    this.getVehicleStatusData();

    // Load status cards data
    this.getStatusCardsData();

    // Load fuel card data
    this.getFuelCardData();

    // Load dream step data
    this.getDreamStepData();

    // Load live vehicle counts
    // this.getLiveVehicleCounts();

    // Load vehicle live status
    this.getVehicleLiveStatus();

    // Load VMU maintained data
    this.getVmuMaintainedData();

    // Load driver type counts
    this.getDriverTypeCounts();

    // Load top 10 operated ULBs (will also be calculated from ulbTripsDta)
    // this.getTop10OperatedUlbs();

    // Weekly charts will be loaded in ngAfterViewInit
  }

  get_totalDistanceCount(funDt?): any {
    this.ttlDstncCnt = [];
    // this.showLdr = true;
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: 0, //tnt_in: 0 #change
    };
    const rte = `dashboard/enterprise/get_ttlDstnce/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            let res_data = res["data"];
            if (res_data && res_data.length > 0) {
              this.ttlDstncCnt = res["data"];
              console.log(this.ttlDstncCnt, "----------ttlDstncCnt-----------"); //#change
              // Initialize distance pie chart after data loads
              setTimeout(() => this.createDistancePieChart(), 300);
            }
            // this.showLdr = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }
  get_today_Ulb_CoveredTripsCount(funDt?, slctTnt?): any {
    this.tdyCoveredTrips = [];
    // this.showLdr = true;
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/ulb_tdy/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data && res_data.length > 0) {
              this.tdyCoveredTrips = res["data"];
              console.log(this.tdyCoveredTrips);
              // Set owner counts from ulb_tdy response
              const d = res_data[0];
              this.overallOwnerCounts = {
                own: d.own_ct || 0,
                contract: d.contract_ct || 0,
                sac: d.sac_ct || 0,
              };
              this.primaryOwnerCounts = {
                own: d.primary_own || 0,
                contract: d.primary_contract || 0,
                sac: d.primary_sac || 0,
              };
              this.secondaryOwnerCounts = {
                own: d.secondary_own || 0,
                contract: d.secondary_contract || 0,
                sac: d.secondary_sac || 0,
              };
              // Initialize working hours pie chart after data loads
              setTimeout(() => this.createWorkingHoursPieChart(), 300);
            }
            // this.showLdr = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  get_totalTripsCount(funDt?): any {
    this.ttlTrpsCnt = [];
    // this.showLdr = true;
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 0,
    };
    let rte = `dashboard/enterprise/ttlTrips/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          let res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.ttlTrpsCnt = res["data"];
          }
          // this.showLdr = false;
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  get_prmryTripsCount(funDt?): any {
    this.prmryTrpsCnt = [];
    // this.showLdr = true;
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 0,
    };
    let rte = `dashboard/enterprise/get_prmryTrips`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        let res_data = res["data"];
        if (res_data && res_data.length > 0) {
          this.prmryTrpsCnt = res["data"];
          console.log(this.prmryTrpsCnt);
          this.shwzrwErr = false;
        } else {
          this.shwzrwErr = true;
        }
        // this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  get_scndryTripsCount(funDt?): any {
    this.scndryTrpsCnt = [];
    // this.showLdr = true;
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 0,
    };
    let rte = `dashboard/enterprise/get_scndryTrips`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        let res_data = res["data"];
        if (res_data && res_data.length > 0) {
          this.scndryTrpsCnt = res["data"];
          console.log(this.scndryTrpsCnt);
          this.shwScndryzrwErr = false;
        } else {
          this.shwScndryzrwErr = true;
        }
        // this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  get_ulbWsedta(funDt?): any {
    this.ulbTripsDta = [];
    this.showLdr = true; // Show loader while loading ULB data
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 0,
    };
    const rte = `dashboard/enterprise/dta_ulb/${this.dbrd_ky}`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          let res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.ulbTripsDta = res["data"];
            this.filteredUlbList = [...this.ulbTripsDta]; // Initialize filtered list
            this.showLdr = false; // Hide loader after ULB data is loaded
            console.log(this.ulbTripsDta);
            if (this.ulbTripsDta.length <= 8 && this.ulbTripsDta.length > 1) {
              this.ulblable = "Zone";
            } else {
              this.ulblable = "ULB Name";
            }
            // If map view is active, update markers
            if (this.currentView === "map" && this.map) {
              setTimeout(() => {
                this.plotMarkers();
              }, 100);
            }
            this.ulbTripscolumnDefs = [
              {
                headerName: "S.No",
                field: "sno",
                alignment: "center",
                width: 60,
                filter: false,
                cellClass: "pm-grid-number-cell",
                search: false,
                summaryType: false,
              },
              {
                headerName: "District",
                alignment: "left",
                width: 150,
                field: "dstrct_nm",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: this.ulblable,
                alignment: "left",
                width: 150,
                field: "tnt_dsply_nm",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Total Vehicles",
                alignment: "center",
                field: "tot_veh",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Operated Vehicles",
                field: "operated",
                alignment: "center",
                summaryType: "sum",
              },
              {
                headerName: "Non Operated Vehicles",
                field: "notoperated",
                alignment: "center",
                summaryType: "sum",
              },
              {
                headerName: "Operated %",
                field: "opper",
                alignment: "center",
                summaryType: "avg",
                format: { type: "fixedPoint", precision: 2 },
              },
              {
                headerName: "Total Trips",
                alignment: "center",
                field: "totl_trps",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Travelled Trips",
                alignment: "center",
                field: "trvld_trps",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Trips %",
                alignment: "center",
                field: "trvl_prcntg",
                cellClass: "pm-grid-number-cell",
                summaryType: "avg",
                format: { type: "fixedPoint", precision: 2 },
              },
              {
                headerName: "Yet to start",
                field: "yet_to_strt",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Running",
                field: "running",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Route Deviated",
                field: "rd_cnt",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Travelled below 30 Km",
                field: "blw_30_veh_ct",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Ignition on/off vehicles",
                field: "igntn_ct",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
            ];
            this.smryClmns = [
              {
                headerName: "Total Vehicles",
                alignment: "center",
                field: "tot_veh",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Operated Vehicles",
                field: "operated",
                alignment: "center",
                summaryType: "sum",
              },
              {
                headerName: "Non Operated Vehicles",
                field: "notoperated",
                alignment: "center",
                summaryType: "sum",
              },
              {
                headerName: "Operated %",
                field: "opper",
                alignment: "center",
                summaryType: "avg",
                format: { type: "fixedPoint", precision: 2 },
              },
              {
                headerName: "Total Trips",
                alignment: "center",
                field: "totl_trps",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Travelled Trips",
                alignment: "center",
                field: "trvld_trps",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Trips %",
                alignment: "center",
                field: "trvl_prcntg",
                cellClass: "pm-grid-number-cell",
                summaryType: "avg",
                format: { type: "fixedPoint", precision: 2 },
              },
              {
                headerName: "Yet to start",
                field: "yet_to_strt",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Running",
                field: "running",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Route Deviated",
                field: "rd_cnt",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
              {
                headerName: "Travelled below 30 Km",
                field: "blw_30_veh_ct",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                summaryType: "sum",
              },
            ];
            // Calculate Top 10 Operated ULBs from loaded data
            this.calculateTop10OperatedUlbs();
          } else {
            this.ulbTripsDta = [];
            this.filteredUlbList = [];
            this.showLdr = false; // Hide loader if no data
          }

          this.showLdr = false; // Hide loader after response
        } else {
          this.ulbTripsDta = [];
          this.filteredUlbList = [];
          this.showLdr = false; // Hide loader if status is not 200
        }
      },
      (err) => {
        this.ulbTripsDta = [];
        this.filteredUlbList = [];
        this.showLdr = false; // Hide loader on error
        console.error("Error loading ULB data:", err);
      }
    );
  }

  get_ctgrywisecounts(funDt?): any {
    this.ctgryWseCnts = [];
    // this.showLdr = true;
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTmspDate = moment(this.slctdDt).format("YYYY-MM-DD HH:mm:ss");
    // console.log(this.curDate,this.curTmspDate);
    this.postslctdDt = {
      dt: this.curDate,
      dtsp: this.curTmspDate,
      tnt_in: 0,
    };
    let rte = `dashboard/enterprise/get_ctgryWiseCnts`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          let res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.ctgryWseCnts = res["data"];
            // console.log(this.ctgryWseCnts);
          }
          if (res_data.length > 10) {
            this.ispagination = true;
          }
          // this.showLdr = false;
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  gotoUlb(event) {
    console.log(event.row.data);
    this.TransfereService.setLoclData("ulbDta", event.row.data);
    this.route.navigate([`internal/dashboard/ulb-dashboard`]);
  }
  onCellPrepared(colDef, e) {
    if (e.rowType === "data" && e.columnIndex == 2) {
      e.cellElement.style.color = "#1d4ed8";
      e.cellElement.style.fontWeight = 500;
      e.cellElement.style.borderRadius = "10px";
      // e.cellElement.style.background = 'rgba(243, 191, 176, 0.2784313725490196)';
      e.cellElement.style.backgroundClip = "content-box";
      e.cellElement.style.cursor = "pointer";
    }
  }
  getbelowThirtyKmVehicles(funDt?) {
    this.slctdDt = funDt;
    // this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    let rte = `dashboard/enterprise/get_below_ThirtyKm_Vehicles/${this.curDate}`;
    this.apiServ.get(rte).subscribe(
      (res) => {
        let res_data = res["data"];
        if (res_data && res_data.length > 0) {
          this.ThrtyKmbelowVehcles = res["data"];
          this.ThrtyKmbelowVehclescolumnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 60,
              filter: false,
            },
            {
              headerName: "ULB Name",
              alignment: "left",
              width: 160,
              field: "tnt_nm",
            },
            {
              headerName: "Travelled Below 30 kms",
              field: "les_cnt",
              width: 120,
              alignment: "center",
            },
          ];
        }
        // this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  getVehiclesOperatedcntsULBwise(funDt?) {
    this.slctdDt = funDt;
    // this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");

    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: 0,
    };
    let rte = `dashboard/enterprise/get_ulbwise_operated_Vehicles`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.ulbwseopratedTripsTble = res["data"];
            let counter = 0;
            this.ulbwseopratedTripsTble.filter((k) => {
              k["sno"] = ++counter;
            });
            this.ulbwseopratedTripsTblecolumnDefs = [
              {
                headerName: "S.No",
                field: "sno",
                alignment: "center",
                width: 60,
                filter: false,
              },
              {
                headerName: "ULB Name",
                alignment: "left",
                width: 180,
                field: "tnt_nm",
              },
              {
                headerName: "Total Vehicles",
                field: "ttl",
                width: 180,
                alignment: "center",
              },
              {
                headerName: "Operated Vehicles",
                field: "operated",
                width: 180,
                alignment: "center",
              },
              {
                headerName: "Non Operated Vehicles",
                field: "notoperated",
                width: 180,
                alignment: "center",
              },
              {
                headerName: "Operated%",
                field: "opper",
                width: 180,
                alignment: "center",
              },
            ];
          }
          if (res_data.length > 10) {
            this.ispagination1 = true;
          }
          // this.showLdr = false;
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  getVehiclesOperatedcntsVndrULBwise(funDt?) {
    this.slctdDt = funDt;
    // this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    let rte = `dashboard/enterprise/get_vndrwise_operated_Vehicles/${this.curDate}/${this.dbrd_ky}`;
    this.apiServ.get(rte).subscribe(
      (res) => {
        let res_data = res["data"];
        if (res_data && res_data.length > 0) {
          this.ulbVndrwseopratedTripsTble = res["data"];
          // let counter = 0;
          //   this.ulbVndrwseopratedTripsTble.filter((k) => {
          //     k['sno'] = ++counter;
          //   });
          this.ulbVndrwseopratedTripsTblecolumnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 60,
              filter: false,
            },
            {
              headerName: "Zone",
              alignment: "left",
              width: 90,
              field: "zone_nm",
            },
            {
              headerName: "Vendor Name",
              alignment: "left",
              width: 140,
              field: "vndr_nm",
            },
            // { headerName: 'ULB Name', alignment: 'left', width: 200, field: 'tnt_nm' },
            {
              headerName: "No of Locations",
              alignment: "center",
              field: "ulb_ct",
            },
            { headerName: "Total Vehicles", field: "ttl", alignment: "center" },
            {
              headerName: "Online Vehicles",
              field: "online_ct",
              alignment: "center",
            },
            {
              headerName: "Offline Vehicles",
              field: "offline_ct",
              alignment: "center",
            },
            {
              headerName: "Operated Vehicles",
              field: "operated",
              alignment: "center",
            },
            {
              headerName: "Non Operated Vehicles",
              field: "notoperated",
              alignment: "center",
            },
            { headerName: "Operated %", field: "op_prct", alignment: "center" },
          ];
        }

        // this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  cardOne() {
    this.crdOne = true;
    this.crdTwo = false;
    this.crdThree = false;
    this.crdFour = false;
    this.urbn_in = 1;
    this.getChrtsData(1);
  }
  cardTwo() {
    this.crdOne = false;
    this.crdTwo = true;
    this.crdThree = false;
    this.crdFour = false;
    this.urbn_in = 1;
    this.getChrtsData(1);
  }
  cardThree() {
    this.crdOne = false;
    this.crdTwo = false;
    this.crdThree = true;
    this.crdFour = false;
    this.urbn_in = 1;
    this.getChrtsData(1);
  }
  cardFour() {
    this.crdOne = false;
    this.crdTwo = false;
    this.crdThree = false;
    this.crdFour = true;
    this.urbn_in = 1;
    this.getChrtsData(1);
  }

  // Toggle Primary Vehicle Owner Type expansion
  // Get Overall Vehicle Owner Type Counts (Own/Contract/SAC by asrt_ownr_id)
  getOverallOwnerCounts(): void {
    const postData = {
      dt: moment(this.slctdDt).format("YYYY-MM-DD"),
      slctd_tnt: 0,
    };
    let rte = `dashboard/enterprise/get_vehicle_owner_counts/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.overallOwnerCounts = {
                own: data.own || 0,
                contract: data.contract || 0,
                sac: data.sac || 0,
              };
            }
            console.log("Overall Owner Counts:", this.overallOwnerCounts);
          }
        },
        (err) => {
          console.error("Error fetching overall owner counts:", err);
        }
      );
  }

  togglePrimaryOwnerExpand(): void {
    this.isPrimaryOwnerExpanded = !this.isPrimaryOwnerExpanded;
    if (this.isPrimaryOwnerExpanded) {
      this.getPrimaryOwnerCounts();
    }
  }

  // Close Primary Vehicle Owner Type expansion
  closePrimaryOwnerExpand(): void {
    this.isPrimaryOwnerExpanded = false;
  }

  // Toggle Secondary Vehicle Owner Type expansion
  toggleSecondaryOwnerExpand(): void {
    this.isSecondaryOwnerExpanded = !this.isSecondaryOwnerExpanded;
    if (this.isSecondaryOwnerExpanded) {
      this.getSecondaryOwnerCounts();
    }
  }

  // Close Secondary Vehicle Owner Type expansion
  closeSecondaryOwnerExpand(): void {
    this.isSecondaryOwnerExpanded = false;
  }

  // Get Primary Vehicle Owner Type Counts (Own/Contract/SAC by asrt_ownr_id)
  getPrimaryOwnerCounts(): void {
    const postData = {
      dt: moment(this.slctdDt).format("YYYY-MM-DD"),
      slctd_tnt: 0,
      veh_type: "primary", // 1000001
    };
    let rte = `dashboard/enterprise/get_vehicle_owner_counts/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.primaryOwnerCounts = {
                own: data.own || 0,
                contract: data.contract || 0,
                sac: data.sac || 0,
              };
            }
            console.log("Primary Owner Counts:", this.primaryOwnerCounts);
          }
        },
        (err) => {
          console.error("Error fetching primary owner counts:", err);
        }
      );
  }

  // Get Secondary Vehicle Owner Type Counts (Own/Contract/SAC by asrt_ownr_id)
  getSecondaryOwnerCounts(): void {
    const postData = {
      dt: moment(this.slctdDt).format("YYYY-MM-DD"),
      slctd_tnt: 0,
      veh_type: "secondary", // 1000000
    };
    let rte = `dashboard/enterprise/get_vehicle_owner_counts/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.secondaryOwnerCounts = {
                own: data.own || 0,
                contract: data.contract || 0,
                sac: data.sac || 0,
              };
            }
            console.log("Secondary Owner Counts:", this.secondaryOwnerCounts);
          }
        },
        (err) => {
          console.error("Error fetching secondary owner counts:", err);
        }
      );
  }

  getChrtsData(u_in) {
    this.showLdr = true;
    let rte = `dashboard/enterprise/state/ulb-charts-data/${u_in}/${this.dbrd_ky}`;
    this.apiServ.get(rte).subscribe(
      (res) => {
        let res_data = res["data"];
        this.chartsData = res["data"];
        this.showLdr = false;
        if (this.crdOne == true) {
          let chart1 = am4core.create("urbanVehiclesChart", am4charts.XYChart);
          chart1.data = this.chartsData;

          let categoryAxis1 = chart1.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis1.dataFields.category = "tnt_nm";
          categoryAxis1.renderer.grid.template.location = 0;
          categoryAxis1.renderer.minGridDistance = 10;
          categoryAxis1.renderer.labels.template.rotation = -90;
          categoryAxis1.renderer.labels.template.fontSize = 12;
          categoryAxis1.renderer.labels.template.dx = -23;

          categoryAxis1.title.text = ` ----- ULBs  ----- `;

          let valueAxis1 = chart1.yAxes.push(new am4charts.ValueAxis());
          valueAxis1.title.text = "-- Vehicles -- ";

          // Create series
          function createSeries(field, name, clr) {
            // Set up series
            let series1 = chart1.series.push(new am4charts.ColumnSeries());
            series1.name = name;
            series1.dataFields.valueY = field;
            series1.dataFields.categoryX = "tnt_nm";
            series1.sequencedInterpolation = true;
            series1.fill = am4core.color(clr);

            // Make it stacked
            series1.stacked = true;

            // Configure columns
            series1.columns.template.width = am4core.percent(60);
            series1.columns.template.tooltipText =
              "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
            // Add label
            let labelBullet = series1.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "[bold]{valueY}";
            labelBullet.label.fill = am4core.color("#ffff");
            labelBullet.locationY = 0.5;
            labelBullet.label.hideOversized = true;

            return series1;
          }
          chart1.legend = new am4charts.Legend();
          createSeries("actve_urbn_ttl", "Active Vehicles", "#185aad");
          createSeries("inact_urban_ttl", "Spare Vehicles", "#ed844e");
        }
        if (this.crdTwo == true) {
          let chart2 = am4core.create(
            "urbanoperStatusChart",
            am4charts.XYChart
          );
          chart2.data = this.chartsData;

          let categoryAxis2 = chart2.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis2.dataFields.category = "tnt_nm";
          categoryAxis2.renderer.grid.template.location = 0;
          categoryAxis2.renderer.minGridDistance = 10;
          categoryAxis2.renderer.labels.template.rotation = -90;
          categoryAxis2.renderer.labels.template.fontSize = 12;
          categoryAxis2.renderer.labels.template.dx = -23;

          categoryAxis2.title.text = ` ----- ULBs  ----- `;

          let valueAxis2 = chart2.yAxes.push(new am4charts.ValueAxis());
          valueAxis2.title.text = "-- Vehicles -- ";

          // Create series
          function createSeries(field, name, clr) {
            // Set up series
            let series2 = chart2.series.push(new am4charts.ColumnSeries());
            series2.name = name;
            series2.dataFields.valueY = field;
            series2.dataFields.categoryX = "tnt_nm";
            series2.sequencedInterpolation = true;
            series2.fill = am4core.color(clr);

            // Make it stacked
            series2.stacked = true;

            // Configure columns
            series2.columns.template.width = am4core.percent(60);
            series2.columns.template.tooltipText =
              "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
            // Add label
            let labelBullet = series2.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "[bold]{valueY}";
            labelBullet.label.fill = am4core.color("#ffff");
            // .fontcolor('#ffff');
            labelBullet.locationY = 0.5;
            labelBullet.label.hideOversized = true;

            return series2;
          }
          chart2.legend = new am4charts.Legend();
          createSeries("u_operated", "Operated Vehicles", "#fddd33");
          createSeries("u_notoperated", "Not Operated Vehicles", "#2751bf");
        }
        if (this.crdThree == true) {
          let chart3 = am4core.create("urbantrvlVhcleChart", am4charts.XYChart);
          chart3.data = this.chartsData;

          let categoryAxis3 = chart3.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis3.dataFields.category = "tnt_nm";
          categoryAxis3.renderer.grid.template.location = 0;
          categoryAxis3.renderer.minGridDistance = 10;
          categoryAxis3.renderer.labels.template.rotation = -90;
          categoryAxis3.renderer.labels.template.fontSize = 12;
          categoryAxis3.renderer.labels.template.dx = -23;

          categoryAxis3.title.text = ` ----- ULBs  ----- `;

          let valueAxis3 = chart3.yAxes.push(new am4charts.ValueAxis());
          valueAxis3.title.text = "-- Vehicles -- ";

          // Create series
          function createSeries(field, name, clr) {
            // Set up series
            let series3 = chart3.series.push(new am4charts.ColumnSeries());
            series3.name = name;
            series3.dataFields.valueY = field;
            series3.dataFields.categoryX = "tnt_nm";
            series3.sequencedInterpolation = true;
            series3.fill = am4core.color(clr);

            // Make it stacked
            series3.stacked = true;

            // Configure columns
            series3.columns.template.width = am4core.percent(60);
            series3.columns.template.tooltipText =
              "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
            // Add label
            let labelBullet = series3.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "[bold]{valueY}";
            labelBullet.label.fill = am4core.color("#ffff");
            labelBullet.locationY = 0.5;
            labelBullet.label.hideOversized = true;

            return series3;
          }
          chart3.legend = new am4charts.Legend();
          createSeries("urbn_tdydst_abv30", ">= 30 kms", "#29989d");
          createSeries("urbn_tdydst_blw30", "< 30 Kms", "#d9809c");
        }
        if (this.crdFour == true) {
          let chart4 = am4core.create("urbantripCvrdChart", am4charts.XYChart);
          chart4.data = this.chartsData;

          let categoryAxis4 = chart4.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis4.dataFields.category = "tnt_nm";
          categoryAxis4.renderer.grid.template.location = 0;
          categoryAxis4.renderer.minGridDistance = 10;
          categoryAxis4.renderer.labels.template.rotation = -90;
          categoryAxis4.renderer.labels.template.fontSize = 12;
          categoryAxis4.renderer.labels.template.dx = -23;

          categoryAxis4.title.text = ` ----- ULBs  ----- `;

          let valueAxis4 = chart4.yAxes.push(new am4charts.ValueAxis());
          valueAxis4.title.text = "-- Vehicles -- ";

          // Create series
          function createSeries(field, name, clr) {
            // Set up series
            let series4 = chart4.series.push(new am4charts.ColumnSeries());
            series4.name = name;
            series4.dataFields.valueY = field;
            series4.dataFields.categoryX = "tnt_nm";
            series4.sequencedInterpolation = true;
            series4.fill = am4core.color(clr);

            // Make it stacked
            series4.stacked = true;

            // Configure columns
            series4.columns.template.width = am4core.percent(60);
            series4.columns.template.tooltipText =
              "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
            // Add label
            let labelBullet = series4.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "[bold]{valueY}";
            labelBullet.label.fill = am4core.color("#ffff");
            labelBullet.locationY = 0.5;
            labelBullet.label.hideOversized = true;

            return series4;
          }
          // chart4.legend = new am4charts.Legend();
          createSeries("trvl_prcntg", "Trips Travelled %", "#29989d");

          // createSeries('urbn_tdydst_blw30', '< 30 Kms');
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  // onExporting1() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  createUlbVehiclesPdf() {
    if (!this.ulbTripsDta || !this.ulbTripsDta.length) {
      return;
    }

    const reportName = "ULB Wise Vehicles";
    const visibleCols = (this.ulbTripscolumnDefs || []).filter(
      (c: any) => !c.hide
    );
    const head: string[] = visibleCols.map((c: any) => c.headerName);
    const body: any[][] = this.ulbTripsDta.map((row: any) =>
      visibleCols.map((c: any) => {
        if (c.field === "igntn_ct") {
          return `${row.igntn_on_cnt || 0} / ${row.igntn_off_cnt || 0}`;
        }
        const val = row[c.field];
        return val === null || val === undefined ? "" : val;
      })
    );

    const pdfSize = "a4";
    const pageMode = "l";
    const reqFontSize = 8;
    const doc = new jsPDF(pageMode, "mm", pdfSize);
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const centerX = pageWidth / 2;
    const ovrAllWidth = 30;
    const ovrAllHeight = 25;

    let logoTx: string | undefined;
    let rptHdrTx = "";
    const tnt0 = this.clntDtls?.[0]?.tnts?.[0];

    if (
      this.userDtls?.clap_in == 1 &&
      this.clntDtls?.[0]?.tnts != 2000439 &&
      this.clntDtls?.[0]?.clnt_id == 7
    ) {
      logoTx = "assets/images/logo/swatchAndraLgo.png";
      rptHdrTx = "SWACHHA ANDHRA CORPORATION";
    } else if (
      (this.userDtls?.clap_in == 0 || this.userDtls?.clap_in == 2) &&
      this.clntDtls?.[0]?.tnts != 2000439 &&
      this.clntDtls?.[0]?.clnt_id == 7
    ) {
      logoTx = tnt0?.tnt_lgo_url_tx;
      rptHdrTx = (tnt0?.tnt_dsply_nm || "") + " Municipal corporation";
    } else if (this.clntDtls?.[0]?.clnt_id != 7) {
      logoTx = this.clntDtls?.[0]?.clnt_lgo_url_tx;
      rptHdrTx = this.clntDtls?.[0]?.clnt_nm || "";
    } else {
      rptHdrTx = "SWACHHA ANDHRA CORPORATION";
    }

    doc.setTextColor("brown");
    doc.setFontSize(16);
    doc.text(rptHdrTx, centerX, 14, { align: "center" });
    doc.setTextColor("black");
    doc.setFontSize(12);
    if (logoTx) {
      try {
        doc.addImage(logoTx, "PNG", 15, 5, ovrAllWidth, ovrAllHeight);
      } catch (e) {
        /* ignore image errors */
      }
    }

    const dateLabel = this.curDate ? ` (${this.curDate})` : "";
    doc.text(reportName + dateLabel, centerX, 22, { align: "center" });

    const rptFooterTx =
      "***This Copy Digitally Signed by Dreamstep Software Innovations Pvt Ltd ***";
    const footerY = pageHeight - 10;

    (doc as any).autoTable({
      head: [head],
      body,
      theme: "grid",
      startY: 31,
      headStyles: { fillColor: [57, 50, 126], fontSize: reqFontSize },
      bodyStyles: { fontSize: reqFontSize },
      styles: { overflow: "linebreak" },
      didDrawPage: () => {
        doc.setTextColor("black");
        doc.setFontSize(9);
        doc.text(rptFooterTx, centerX, footerY, { align: "center" });
      },
    });

    doc.save(reportName + ".pdf");
  }

  // onExporting2() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  ngAfterViewInit(): void {
    // Map will be initialized when view is switched to map
    // Initialize weekly charts after view is initialized
    setTimeout(() => {
      this.getWeeklyDistanceData();
      this.getWeeklyOperationalStatusData();
      this.getFuelLast7DaysData();
    }, 500);

    // Start auto-refresh for Vehicle Live Status every 10 seconds
    this.startVehicleLiveStatusAutoRefresh();
  }

  /**
   * Start auto-refresh interval for Vehicle Live Status API
   * Refreshes every 10 seconds to keep the data live
   */
  startVehicleLiveStatusAutoRefresh(): void {
    // Clear any existing interval
    if (this.vehicleLiveStatusInterval) {
      clearInterval(this.vehicleLiveStatusInterval);
    }
    // Set interval to refresh every 10 seconds (10000 ms)
    this.vehicleLiveStatusInterval = setInterval(() => {
      this.getVehicleLiveStatus();
    }, 10000);
  }

  /**
   * Stop auto-refresh interval for Vehicle Live Status API
   */
  stopVehicleLiveStatusAutoRefresh(): void {
    if (this.vehicleLiveStatusInterval) {
      clearInterval(this.vehicleLiveStatusInterval);
      this.vehicleLiveStatusInterval = null;
    }
  }

  ngOnDestroy(): void {
    // Stop Vehicle Live Status auto-refresh interval
    this.stopVehicleLiveStatusAutoRefresh();

    // Complete the subject to unsubscribe from all observables
    this.destroy$.next();
    this.destroy$.complete();

    if (this.map) {
      this.map.remove();
    }
    if (this.markerLayer) {
      this.markerLayer.clearLayers();
    }
    // Dispose charts
    if (this.chart4) {
      this.chart4.dispose();
    }
    if (this.chart5) {
      this.chart5.dispose();
    }
    if (this.chart) {
      this.chart.dispose();
    }
    if (this.chart2) {
      this.chart2.dispose();
    }
    if (this.chart3) {
      this.chart3.dispose();
    }
    if (this.chart6) {
      this.chart6.dispose();
    }
    // Dispose pie charts
    if (this.distancePieChart) {
      this.distancePieChart.dispose();
    }
    if (this.workingHoursPieChart) {
      this.workingHoursPieChart.dispose();
    }

    // Clear data arrays
    this.ulbTripsDta = [];
    this.tpPrfmnceUlbDta = [];
    this.lstPrfmnceUlbDta = [];
  }

  getWorkingHoursData(): void {
    // Calculate working hours data from available data
    // For now, using placeholder logic - you may need to call an API
    if (this.ttlDstncCnt && this.ttlDstncCnt.length > 0) {
      const data = this.ttlDstncCnt[0];
      // Assuming vehicles with distance >= 500m worked more than 30 min
      // and vehicles with distance < 500m worked 30 min or less
      this.workingHoursData.vehicles30Min = data.urbn_tdydst_blw30 || 0;
      this.workingHoursData.vehiclesMore30Min = data.urbn_tdydst_abv30 || 0;
    }
  }

  getCoverageData(): void {
    // Get coverage data from trips data
    if (this.ttlTrpsCnt && this.ttlTrpsCnt.length > 0) {
      const data = this.ttlTrpsCnt[0];
      this.coverageData.coverage = data.tdy_trps || 0;
      this.coverageData.coveragePercent = data.tdy_per || 0;
    }
  }

  getVehicleStatusData(): void {
    // Get vehicle status data using the API
    // Using 0 for vendor and tenant as this is a state-level dashboard
    const vndrId = 0;
    const tntId = 0;

    this.apiServ
      .get(`drivers/vehicle-wise/ctgry/summary/${vndrId}/${tntId}`)
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            this.vehicleStatusData = res["data"];
            console.log("Vehicle Status Data:", this.vehicleStatusData);
          }
        },
        (err) => {
          console.error("Error fetching vehicle status data:", err);
        }
      );
  }

  getStatusCardsData(): void {
    // Get status cards data (like ams-vehicles component)
    // Using 0 for vendor, tenant, category as this is a state-level dashboard
    const vndrId = 0;
    const tntId = 0;
    const asrtCtgryId = 0;
    const asrtCtgryNm = "null";

    this.apiServ
      .get(
        `drivers/vehicle-wise/cards/summary/${vndrId}/${tntId}/${asrtCtgryId}/${asrtCtgryNm}`
      )
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            this.cardcntSummary = res["data"];
            if (this.cardcntSummary && this.cardcntSummary.length > 0) {
              this.asrt_sts_id = this.cardcntSummary[0].asrt_sts_id;
              this.cardcntSummary[0].crdChnge = true;
            }
            console.log("Status Cards Data:", this.cardcntSummary);

            // Calculate vehicle status counts
            this.calculateVehicleStatusCounts();
          }
        },
        (err) => {
          console.error("Error fetching status cards data:", err);
        }
      );
  }

  calculateVehicleStatusCounts(): void {
    // Reset counts
    this.vehicleStatusCounts = {
      total: 0,
      online: 0,
      offline: 0,
      repair: 0,
      others: 0,
    };

    if (!this.cardcntSummary || this.cardcntSummary.length === 0) {
      return;
    }

    // Categorize statuses similar to live-tracking logic
    // Live-tracking uses: asrtglblId == 1 (Online), == 2 (Offline), == 3 (Repair), others
    this.cardcntSummary.forEach((status: any) => {
      const count = parseInt(status.ct) || 0;
      const statusName = (status.asrt_sts_nm || "").toLowerCase().trim();

      // Skip "Total" row (it's a summary row, not a status)
      if (
        statusName === "total" ||
        status.asrt_glbl_sts_id === 0 ||
        status.asrtglblId === 0
      ) {
        return;
      }

      // Check if asrt_glbl_sts_id is available (preferred method, same as live-tracking)
      const glblStsId =
        status.asrt_glbl_sts_id !== undefined &&
        status.asrt_glbl_sts_id !== null
          ? parseInt(status.asrt_glbl_sts_id)
          : status.asrtglblId !== undefined && status.asrtglblId !== null
          ? parseInt(status.asrtglblId)
          : null;

      if (glblStsId !== null && glblStsId !== 0) {
        if (glblStsId === 1) {
          // Online
          this.vehicleStatusCounts.online += count;
        } else if (glblStsId === 2) {
          // Offline
          this.vehicleStatusCounts.offline += count;
        } else if (glblStsId === 3) {
          // Repair
          this.vehicleStatusCounts.repair += count;
        } else {
          // Others (not 1, 2, or 3, and not 0 which is Total)
          this.vehicleStatusCounts.others += count;
        }
      } else {
        // Fallback to status name matching if asrt_glbl_sts_id is not available
        if (statusName === "online" || statusName.includes("online")) {
          this.vehicleStatusCounts.online += count;
        } else if (statusName === "offline" || statusName.includes("offline")) {
          this.vehicleStatusCounts.offline += count;
        } else if (statusName === "repair" || statusName.includes("repair")) {
          this.vehicleStatusCounts.repair += count;
        } else if (statusName !== "total") {
          // Everything else (except Total) goes to others
          this.vehicleStatusCounts.others += count;
        }
      }
    });

    // Calculate total as sum of online, offline, repair, and others
    this.vehicleStatusCounts.total =
      this.vehicleStatusCounts.online +
      this.vehicleStatusCounts.offline +
      this.vehicleStatusCounts.repair +
      this.vehicleStatusCounts.others;

    console.log("Vehicle Status Counts Calculated:", {
      total: this.vehicleStatusCounts.total,
      online: this.vehicleStatusCounts.online,
      offline: this.vehicleStatusCounts.offline,
      repair: this.vehicleStatusCounts.repair,
      others: this.vehicleStatusCounts.others,
      breakdown: `Total = ${this.vehicleStatusCounts.online} (Online) + ${this.vehicleStatusCounts.offline} (Offline) + ${this.vehicleStatusCounts.repair} (Repair) + ${this.vehicleStatusCounts.others} (Others)`,
      sourceData: this.cardcntSummary.map((s) => ({
        name: s.asrt_sts_nm,
        count: s.ct,
        glbl_sts_id: s.asrt_glbl_sts_id || s.asrtglblId,
      })),
    });
  }

  cardchnge(sts: any): void {
    this.asrt_sts_id = sts;
    // Reset all cards
    this.cardcntSummary.forEach((e) => {
      e.crdChnge = false;
      if (e.asrt_sts_id == sts) {
        e.crdChnge = true;
      }
    });
    // You can add filtering logic here if needed
  }

  toggleView(view: "table" | "map"): void {
    this.currentView = view;
    if (view === "map") {
      setTimeout(() => {
        this.initializeMap();
        this.plotMarkers();
      }, 100);
    } else {
      // Reset selected ULB when switching to table view
      this.selectedUlbData = null;
      this.selectedUlbIndex = 0;
    }
  }

  initializeMap(): void {
    if (this.map) {
      this.map.remove();
    }

    // Initialize map with default center (India)
    this.map = L.map("urban-dashboard-map", {
      center: [17.6905, 83.2123],
      zoom: 6,
      zoomControl: true,
      minZoom: 5,
      maxZoom: 20,
    });

    // Add OpenStreetMap tile layer
    const tiles = L.tileLayer(
      "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      {
        maxZoom: 20,
        minZoom: 5,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
        attribution: "",
      }
    );

    tiles.addTo(this.map);

    // Initialize marker layer group
    this.markerLayer = L.layerGroup().addTo(this.map);

    // Initialize boundary layer group
    this.boundaryLayer = L.layerGroup().addTo(this.map);

    // Ensure map is properly rendered and invalidate size after a short delay
    setTimeout(() => {
      if (this.map) {
        this.map.invalidateSize();
        // Trigger a resize event to ensure tiles load properly
        window.dispatchEvent(new Event("resize"));
      }
    }, 300);
  }

  plotMarkers(): void {
    if (!this.map || !this.ulbTripsDta || this.ulbTripsDta.length === 0) {
      return;
    }

    // Clear existing markers and boundaries
    if (this.markerLayer) {
      this.markerLayer.clearLayers();
    }
    if (this.boundaryLayer) {
      this.boundaryLayer.clearLayers();
    }
    this.markers = [];

    const bounds: L.LatLngBounds = L.latLngBounds([]);

    // Plot boundaries and markers for each tenant
    this.ulbTripsDta.forEach((tenant: any, index: number) => {
      // Find tenant in tntLst to get lat/lng
      const tenantInfo = this.tntLst.find(
        (t: any) => t.tnt_id === tenant.tnt_id
      );

      if (tenantInfo) {
        const lat = tenantInfo.lat ? parseFloat(tenantInfo.lat) : null;
        const lng = tenantInfo.lng ? parseFloat(tenantInfo.lng) : null;
        const totalVehicles = tenant.tot_veh || tenant.ttl || 0;

        // Plot boundary if bndry_jsn exists
        if (tenant.bndry_jsn) {
          try {
            const boundaryData =
              typeof tenant.bndry_jsn === "string"
                ? JSON.parse(tenant.bndry_jsn)
                : tenant.bndry_jsn;

            if (Array.isArray(boundaryData) && boundaryData.length > 0) {
              // Handle GeoJSON or coordinate array
              let coordinates = boundaryData;

              // If it's GeoJSON format
              if (boundaryData[0] && boundaryData[0].type === "Feature") {
                coordinates = boundaryData[0].geometry.coordinates[0];
              } else if (boundaryData[0] && Array.isArray(boundaryData[0][0])) {
                coordinates = boundaryData[0];
              }

              // Convert coordinates to LatLng array
              const latlngs = coordinates
                .map((coord: any) => {
                  // Handle [lng, lat] or [lat, lng] format
                  if (Array.isArray(coord) && coord.length >= 2) {
                    // Check if first value is longitude (usually > 0 and < 180) or latitude
                    if (
                      coord[0] > -90 &&
                      coord[0] < 90 &&
                      coord[1] > -180 &&
                      coord[1] < 180
                    ) {
                      return [coord[0], coord[1]]; // [lat, lng]
                    } else {
                      return [coord[1], coord[0]]; // [lng, lat] -> [lat, lng]
                    }
                  }
                  return null;
                })
                .filter((c: any) => c !== null);

              if (latlngs.length > 0) {
                const polygon = L.polygon(latlngs, {
                  color:
                    index === this.selectedUlbIndex ? "#ef4444" : "#3b82f6",
                  weight: index === this.selectedUlbIndex ? 3 : 2,
                  opacity: 0.8,
                  fillColor:
                    index === this.selectedUlbIndex ? "#ef4444" : "#3b82f6",
                  fillOpacity: 0.2,
                } as any).addTo(this.boundaryLayer);

                // Store ULB index and data in polygon for later reference
                (polygon as any).ulbIndex = index;
                (polygon as any).ulbData = tenant;

                // Add click event to boundary polygon to focus on ULB
                polygon.on("click", () => {
                  this.selectUlb(tenant, index);
                });

                // Extend bounds with polygon
                polygon.getBounds() && bounds.extend(polygon.getBounds());
              }
            }
          } catch (e) {
            console.warn(
              "Error parsing boundary JSON for tenant:",
              tenant.tnt_nm,
              e
            );
          }
        }

        // Plot marker if lat/lng exists
        if (lat && lng) {
          const radius = 15;

          // Create circle marker
          const circleMarker = L.circleMarker([lat, lng], {
            radius: radius,
            fillColor: index === this.selectedUlbIndex ? "#ef4444" : "#3b82f6",
            color: index === this.selectedUlbIndex ? "#ef4444" : "#3b82f6",
            weight: index === this.selectedUlbIndex ? 3 : 2,
            opacity: 1,
            fillOpacity: 0.9,
          }).addTo(this.markerLayer);

          // Create text label
          const labelHtml = `
            <div class="circle-marker-label" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; pointer-events: none;">
              <span class="label-count" style="color: #ffffff !important; font-size: 11px; font-weight: 700; text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5), 0 0 2px rgba(0, 0, 0, 0.3); line-height: 1; display: block;">${totalVehicles}</span>
            </div>
          `;

          const labelIcon = L.divIcon({
            className: "circle-label-icon",
            html: labelHtml,
            iconSize: [radius * 2, radius * 2],
            iconAnchor: [radius, radius],
          });

          const labelMarker = L.marker([lat, lng], {
            icon: labelIcon,
            interactive: false,
            zIndexOffset: 1000,
          }).addTo(this.markerLayer);

          // Add click event
          circleMarker.on("click", () => {
            this.selectUlb(tenant, index);
          });

          this.markers.push(circleMarker);
          this.markers.push(labelMarker);
          bounds.extend([lat, lng]);
        }
      }
    });

    // Set default selected ULB (first one)
    if (this.ulbTripsDta.length > 0 && !this.selectedUlbData) {
      this.selectUlb(this.ulbTripsDta[0], 0);
    }

    // Fit map to show all markers/boundaries
    if (bounds.isValid()) {
      this.map.fitBounds(bounds, { padding: [50, 50] });
    }
  }

  selectUlb(ulb: any, index: number): void {
    this.selectedUlbData = ulb;
    this.selectedUlbIndex = index;

    // Find tenant info for lat/lng
    const tenantInfo = this.tntLst.find((t: any) => t.tnt_id === ulb.tnt_id);

    if (!this.map) {
      return;
    }

    // First, replot markers to update colors and get boundary
    this.plotMarkers();

    // Wait a bit for markers/boundaries to be plotted
    setTimeout(() => {
      if (tenantInfo && tenantInfo.lat && tenantInfo.lng) {
        const lat = parseFloat(tenantInfo.lat);
        const lng = parseFloat(tenantInfo.lng);

        // Try to find boundary polygon for this ULB
        let boundaryPolygon: L.Polygon | null = null;
        if (this.boundaryLayer) {
          this.boundaryLayer.eachLayer((layer: any) => {
            if (layer.ulbIndex === index && layer.getBounds) {
              boundaryPolygon = layer as L.Polygon;
            }
          });
        }

        if (boundaryPolygon && boundaryPolygon.getBounds()) {
          // Focus on boundary bounds with zoom level 15
          const bounds = boundaryPolygon.getBounds();
          this.map.fitBounds(bounds, {
            padding: [50, 50],
            maxZoom: 13,
          });

          // Ensure zoom is exactly 13 after fitBounds
          setTimeout(() => {
            const center = bounds.getCenter();
            this.map.setView(center, 13, {
              animate: true,
              duration: 0.5,
            });
          }, 200);
        } else {
          // No boundary, focus on marker location with zoom 13
          this.map.setView([lat, lng], 13, {
            animate: true,
            duration: 0.8,
          });
        }
      }
    }, 100);
  }

  closeTenantDetails(): void {
    this.hoveredTenantData = null;
  }

  /**
   * Filter ULB list based on search text
   */
  filterUlbList(): void {
    if (!this.ulbSearchText || this.ulbSearchText.trim() === "") {
      this.filteredUlbList = [...this.ulbTripsDta];
    } else {
      const searchTerm = this.ulbSearchText.toLowerCase().trim();
      this.filteredUlbList = this.ulbTripsDta.filter((ulb: any) => {
        const ulbName = (ulb.tnt_dsply_nm || ulb.tnt_nm || "").toLowerCase();
        const districtName = (ulb.dstrct_nm || "").toLowerCase();
        return (
          ulbName.includes(searchTerm) || districtName.includes(searchTerm)
        );
      });
    }
  }

  /**
   * Clear search and reset filtered list
   */
  clearUlbSearch(): void {
    this.ulbSearchText = "";
    this.filteredUlbList = [...this.ulbTripsDta];
  }

  /**
   * Get the original index of a ULB in the ulbTripsDta array
   */
  getUlbIndex(ulb: any): number {
    return this.ulbTripsDta.findIndex((u: any) => u.tnt_id === ulb.tnt_id);
  }

  /**
   * Check if ULB is selected
   */
  isUlbSelected(ulb: any): boolean {
    const index = this.getUlbIndex(ulb);
    return this.selectedUlbIndex === index;
  }

  /**
   * Get Weekly Distance Data for 7 days
   */
  getWeeklyDistanceData(): void {
    // Dispose existing chart if it exists
    if (this.chart4) {
      this.chart4.dispose();
    }

    let chart = am4core.create("distanceTavelledChart", am4charts.XYChart);
    this.chart4 = chart;
    chart.data = [];

    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 0,
      slctd_tnt: 0,
    };

    let rte = `dashboard/enterprise/get_last7daydata/${this.dbrd_ky}`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200 && res["data"] && res["data"].length > 0) {
          chart.data = res["data"];

          let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis.dataFields.category = "dt";
          categoryAxis.renderer.grid.template.location = 0;
          categoryAxis.renderer.minGridDistance = 30;
          categoryAxis.title.text = ` ----- Date(${this.curYr})----- `;

          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          // valueAxis.renderer.opposite = true;
          // valueAxis.strictMinMax = true;
          valueAxis.title.text = " ----- Distance ----- ";
          chart.colors.list = [
            am4core.color("#3b82f6"),
            // am4core.color("#ef4444"),
          ];

          function createSeries(field, name, color) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "dt";
            series.name = name;
            series.columns.template.tooltipText =
              "{name} Vehicles in {categoryX}: [bold]{valueY}[/]";
            series.columns.template.fillOpacity = 0.8;
            series.columns.template.fill = am4core.color(color);
            series.columns.template.stroke = am4core.color(color);
            series.columns.template.height = am4core.percent(100);
            series.sequencedInterpolation = false;

            let columnTemplate1 = series.columns.template;
            columnTemplate1.strokeWidth = 1;
            let valueLabel = series.bullets.push(new am4charts.LabelBullet());
            valueLabel.label.text = "{valueY}";
            valueLabel.label.fontSize = 12;
            valueLabel.label.dy = -10;
            columnTemplate1.column.cornerRadiusTopLeft = 5;
            columnTemplate1.column.cornerRadiusTopRight = 5;
            columnTemplate1.strokeOpacity = 1;
          }

          // Create series for distance-based vehicle counts
          if (chart.data.length > 0) {
            const firstData = chart.data[0];
            if (
              firstData.hasOwnProperty("dstnc") &&
              firstData.hasOwnProperty("nt_optrd_dst")
            ) {
              createSeries("dstnc", "Distance (KM) >= 500m", "#3b82f6");
              // createSeries("nt_optrd_dst", "Vehicles (Distance < 500m)", "#ef4444");
            } else {
              // Fallback to operated/not operated if distance fields not available
              createSeries("dstnc", "Distance (KM)", "#3b82f6");
              // createSeries("nt_optrd", "Not Operated", "#ef4444");
            }
          }

          chart.legend = new am4charts.Legend();
          chart.legend.position = "bottom";
        }
      },
      (err) => {
        console.log("Error loading weekly distance data:", err);
      }
    );
  }

  /**
   * Get Weekly Operational Status Data for 7 days
   */
  /**
   * Get Fuel Card Data for both current and previous month using fuel summary API
   * Uses dashboard key (dbrd_ky) to differentiate between state (0) and ULB level
   * Returns: filled/not filled ULBs, diesel/petrol/CNG breakdown with counts, litres, amounts
   */
  getFuelCardData(): void {
    // Use the new monthly API that returns both current and previous month in one call
    const postData = {
      slctd_tnt: 0,
    };

    let rte = `dashboard/enterprise/get_fuel_summary_monthly/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const dataArray = res["data"];
            if (Array.isArray(dataArray) && dataArray.length > 0) {
              // First row is current month (sort_order = 1)
              const currentMonthData = dataArray[0];
              // Second row is previous month (sort_order = 2)
              const prevMonthData = dataArray.length > 1 ? dataArray[1] : null;

              // Set month labels from API response
              this.currentMonthLabel =
                currentMonthData.month_label || moment().format("MMM YYYY");
              this.previousMonthLabel =
                prevMonthData?.month_label ||
                moment().subtract(1, "month").format("MMM YYYY");

              // Map current month data
              this.fuelCardData = {
                totalUlbsFilled: currentMonthData.ulbs_count || 0,
                totalUlbsNotFilled: currentMonthData.ulbs_not_filled || 0,
                totalLitres: currentMonthData.total_litres || 0,
                totalAmount: currentMonthData.total_amount || 0,
                totalEntries: currentMonthData.total_entries || 0,
                vehiclesCount: currentMonthData.vehicles_fueled || 0,
                diesel: {
                  count: currentMonthData.diesel_count || 0,
                  litres: currentMonthData.diesel_litres || 0,
                  amount: currentMonthData.diesel_amount || 0,
                },
                petrol: {
                  count: currentMonthData.petrol_count || 0,
                  litres: currentMonthData.petrol_litres || 0,
                  amount: currentMonthData.petrol_amount || 0,
                },
                cng: {
                  count: currentMonthData.cng_count || 0,
                  kg: currentMonthData.cng_kg || 0,
                  amount: currentMonthData.cng_amount || 0,
                },
                mileageVarianceCount: 0,
              };

              // Map previous month data
              if (prevMonthData) {
                this.prevMonthFuelData = {
                  totalUlbsFilled: prevMonthData.ulbs_count || 0,
                  totalUlbsNotFilled: prevMonthData.ulbs_not_filled || 0,
                  totalLitres: prevMonthData.total_litres || 0,
                  totalAmount: prevMonthData.total_amount || 0,
                  totalEntries: prevMonthData.total_entries || 0,
                  vehiclesCount: prevMonthData.vehicles_fueled || 0,
                  diesel: {
                    count: prevMonthData.diesel_count || 0,
                    litres: prevMonthData.diesel_litres || 0,
                    amount: prevMonthData.diesel_amount || 0,
                  },
                  petrol: {
                    count: prevMonthData.petrol_count || 0,
                    litres: prevMonthData.petrol_litres || 0,
                    amount: prevMonthData.petrol_amount || 0,
                  },
                  cng: {
                    count: prevMonthData.cng_count || 0,
                    kg: prevMonthData.cng_kg || 0,
                    amount: prevMonthData.cng_amount || 0,
                  },
                };
              }

              console.log("Fuel Summary Monthly - Current:", this.fuelCardData);
              console.log(
                "Fuel Summary Monthly - Previous:",
                this.prevMonthFuelData
              );
            }
          }
        },
        (err) => {
          console.error("Error fetching fuel summary monthly data:", err);
        }
      );

    // Get mileage variance data (estimated mileage > actual distance)
    this.getMileageVarianceData();
  }

  /**
   * Get Mileage Variance Data - Count of vehicles where estimated mileage > actual distance
   */
  getMileageVarianceData(): void {
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    const postData = {
      dt: this.curDate,
      slctd_tnt: 0,
    };

    let rte = `dashboard/enterprise/get_mileage_variance/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.fuelCardData.mileageVarianceCount =
                data.mileage_variance_count || data.variance_count || 0;
            }
            console.log(
              "Mileage Variance Count:",
              this.fuelCardData.mileageVarianceCount
            );
          }
        },
        (err) => {
          console.error("Error fetching mileage variance data:", err);
        }
      );
  }

  /**
   * Get Dream Step Maintained Data (IMEI starting with 35151)
   */
  getDreamStepData(): void {
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: 0,
    };

    let rte = `dashboard/enterprise/get_dream_step_data/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = res["data"];
            if (Array.isArray(data) && data.length > 0) {
              this.dreamStepData = {
                count: data[0].dream_step_count || 0,
              };
            } else if (data && !Array.isArray(data)) {
              this.dreamStepData = {
                count: data.dream_step_count || 0,
              };
            }
            console.log("Dream Step Data:", this.dreamStepData);
          }
        },
        (err) => {
          console.error("Error fetching dream step data:", err);
        }
      );
  }

  /**
   * Get VMU Maintained Data (CDMA and ULB sections)
   */
  getVmuMaintainedData(): void {
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: 0,
    };

    let rte = `dashboard/enterprise/get_vmu_maintained_data/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = res["data"];
            if (Array.isArray(data) && data.length > 0) {
              const cdmaTotal = data[0].cdma_total || 0;
              const cdmaOperated = data[0].cdma_operated || 0;
              const ulbTotal = data[0].ulb_total || 0;
              const ulbOperated = data[0].ulb_operated || 0;

              this.vmuMaintainedData = {
                cdma: {
                  total: cdmaTotal,
                  operated: cdmaOperated,
                  notOperated: data[0].cdma_not_operated || 0,
                  operatedPercent:
                    cdmaTotal > 0
                      ? Math.round((cdmaOperated / cdmaTotal) * 100 * 10) / 10
                      : 0,
                },
                ulb: {
                  total: ulbTotal,
                  operated: ulbOperated,
                  notOperated: data[0].ulb_not_operated || 0,
                  operatedPercent:
                    ulbTotal > 0
                      ? Math.round((ulbOperated / ulbTotal) * 100 * 10) / 10
                      : 0,
                },
              };
            }
            console.log("VMU Maintained Data:", this.vmuMaintainedData);
          }
        },
        (err) => {
          console.error("Error fetching VMU maintained data:", err);
        }
      );
  }

  // /**
  //  * Get Live Running and Parked Vehicle Counts
  //  */
  // getLiveVehicleCounts(): void {
  //   let rte = `dashboard/enterprise/get_live_vehicle_counts/${this.dbrd_ky}`;
  //   this.apiServ.get(rte).pipe(takeUntil(this.destroy$)).subscribe((res) => {
  //     if (res['status'] == 200 && res['data']) {
  //       const data = res['data'];
  //       if (Array.isArray(data) && data.length > 0) {
  //         this.liveVehicleCounts = {
  //           running: data[0].running_count || 0,
  //           parked: data[0].parked_count || 0
  //         };
  //       } else if (data && !Array.isArray(data)) {
  //         this.liveVehicleCounts = {
  //           running: data.running_count || 0,
  //           parked: data.parked_count || 0
  //         };
  //       }
  //       console.log('Live Vehicle Counts:', this.liveVehicleCounts);
  //     }
  //   }, (err) => {
  //     console.error('Error fetching live vehicle counts:', err);
  //   });
  // }

  /**
   * Get Vehicle Live Status (Total, Online, Running, Offline, Parked, Repair, 24hr Standby, Others)
   * Customizable API: supports state level (slctd_tnt=0) or ULB level (slctd_tnt=ulb_id)
   */
  getVehicleLiveStatus(ulbId: number = 0): void {
    const postData = {
      slctd_tnt: ulbId, // 0 for state level, specific ULB ID for ULB level
    };

    let rte = `dashboard/enterprise/get_vehicle_live_status/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.vehicleLiveStatus = {
                total: data.total_count || data.total || 0,
                online: data.online_count || data.online || 0,
                running: data.running_count || data.running || 0,
                offline: data.offline_count || data.offline || 0,
                parked: data.parked_count || data.parked || 0,
                repair: data.repair_count || data.repair || 0,
                standby24hr: data.standby_24hr_count || data.standby_24hr || 0,
                onlineStandby24hr:
                  data.online_standby_24hr_count ||
                  data.online_standby_24hr ||
                  0, // Online vehicles in standby for 24 hrs
                offline24hr:
                  data.offline_24hr_count ||
                  data.offline_24hr ||
                  data.standby_24hr_count ||
                  data.standby_24hr ||
                  0, // Vehicles offline > 24 hrs
                others: data.others_count || data.others || 0,
              };
              // Calculate total if not provided by API
              if (!this.vehicleLiveStatus.total) {
                this.vehicleLiveStatus.total =
                  this.vehicleLiveStatus.online +
                  this.vehicleLiveStatus.offline;
              }
            }
            console.log("Vehicle Live Status:", this.vehicleLiveStatus);
          }
        },
        (err) => {
          console.error("Error fetching vehicle live status:", err);
        }
      );
  }

  /**
   * Get Driver Type Counts (OWN/APCOS/CONTRACT)
   * Customizable API: supports state level (slctd_tnt=0) or ULB level (slctd_tnt=ulb_id)
   */
  getDriverTypeCounts(ulbId: number = 0): void {
    const postData = {
      slctd_tnt: ulbId, // 0 for state level, specific ULB ID for ULB level
      dt: moment(this.slctdDt).format("YYYY-MM-DD"), // Selected date for attended/not attended calculation
    };

    let rte = `dashboard/enterprise/get_driver_type_counts/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.driverTypeCounts = {
                total: data.total || data.total_count || 0,
                own: data.own || data.own_count || 0,
                apcos: data.apcos || data.apcos_count || 0,
                contract: data.contract || data.contract_count || 0,
                own_attended: data.own_attended || 0,
                own_not_attended: data.own_not_attended || 0,
                apcos_attended: data.apcos_attended || 0,
                apcos_not_attended: data.apcos_not_attended || 0,
                contract_attended: data.contract_attended || 0,
                contract_not_attended: data.contract_not_attended || 0,
              };
              // Calculate total if not provided
              if (!this.driverTypeCounts.total) {
                this.driverTypeCounts.total =
                  this.driverTypeCounts.own +
                  this.driverTypeCounts.apcos +
                  this.driverTypeCounts.contract;
              }
            }
            console.log("Driver Type Counts:", this.driverTypeCounts);
          }
        },
        (err) => {
          console.error("Error fetching driver type counts:", err);
        }
      );
  }

  /**
   * Get Fuel Last 7 Days Data for Graph
   * Customizable API: supports state level (slctd_tnt=0) or ULB level (slctd_tnt=ulb_id)
   * Shows stacked bar chart with Diesel, Petrol, CNG breakdown
   */
  getFuelLast7DaysData(ulbId: number = 0, days: number = 7): void {
    // Dispose existing chart if exists
    if (this.chart6) {
      this.chart6.dispose();
    }

    let chart = am4core.create("fuelLast7DaysChart", am4charts.XYChart);
    this.chart6 = chart;
    chart.data = [];

    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    const postData = {
      dt: this.curDate,
      slctd_tnt: ulbId, // 0 for state level, specific ULB ID for ULB level
      days: days, // Number of days (default 7)
    };

    let rte = `dashboard/enterprise/get_fuel_last7days/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"] && res["data"].length > 0) {
            this.fuelLast7DaysData = res["data"];
            chart.data = this.fuelLast7DaysData;

            // Category Axis (Dates)
            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "dt";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.minGridDistance = 30;
            categoryAxis.renderer.labels.template.fontSize = 11;
            categoryAxis.title.text = `Date (${this.curYr})`;
            categoryAxis.title.fontSize = 12;

            // Value Axis
            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = "Litres / KG";
            valueAxis.title.fontSize = 12;
            valueAxis.renderer.labels.template.fontSize = 11;

            // Diesel Series (Orange - like Petrol)
            let dieselSeries = chart.series.push(new am4charts.ColumnSeries());
            dieselSeries.dataFields.valueY = "diesel_litres";
            dieselSeries.dataFields.categoryX = "dt";
            dieselSeries.name = "Diesel (L)";
            dieselSeries.stacked = true;
            dieselSeries.columns.template.tooltipText =
              "{categoryX}\nDiesel: [bold]{valueY} L[/]\nAmount: ₹{diesel_amount}";
            dieselSeries.columns.template.fill = am4core.color("#fb923c");
            dieselSeries.columns.template.stroke = am4core.color("#ea580c");
            dieselSeries.columns.template.strokeWidth = 1;

            // Petrol Series (Purple/Violet)
            let petrolSeries = chart.series.push(new am4charts.ColumnSeries());
            petrolSeries.dataFields.valueY = "petrol_litres";
            petrolSeries.dataFields.categoryX = "dt";
            petrolSeries.name = "Petrol (L)";
            petrolSeries.stacked = true;
            petrolSeries.columns.template.tooltipText =
              "{categoryX}\nPetrol: [bold]{valueY} L[/]\nAmount: ₹{petrol_amount}";
            petrolSeries.columns.template.fill = am4core.color("#8b5cf6");
            petrolSeries.columns.template.stroke = am4core.color("#7c3aed");
            petrolSeries.columns.template.strokeWidth = 1;

            // CNG Series (Green)
            let cngSeries = chart.series.push(new am4charts.ColumnSeries());
            cngSeries.dataFields.valueY = "cng_kg";
            cngSeries.dataFields.categoryX = "dt";
            cngSeries.name = "CNG (KG)";
            cngSeries.stacked = true;
            cngSeries.columns.template.tooltipText =
              "{categoryX}\nCNG: [bold]{valueY} KG[/]\nAmount: ₹{cng_amount}";
            cngSeries.columns.template.fill = am4core.color("#22c55e");
            cngSeries.columns.template.stroke = am4core.color("#16a34a");
            cngSeries.columns.template.strokeWidth = 1;

            // Column styling
            chart.series.each((series) => {
              if (series instanceof am4charts.ColumnSeries) {
                series.columns.template.column.cornerRadiusTopLeft = 3;
                series.columns.template.column.cornerRadiusTopRight = 3;
                series.columns.template.fillOpacity = 0.9;
              }
            });

            // Legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "bottom";
            chart.legend.fontSize = 11;
            chart.legend.markers.template.width = 12;
            chart.legend.markers.template.height = 12;

            // Cursor for better interaction
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.lineX.disabled = true;
            chart.cursor.lineY.disabled = true;

            console.log("Fuel Last 7 Days Data:", this.fuelLast7DaysData);
          }
        },
        (err) => {
          console.error("Error fetching fuel last 7 days data:", err);
        }
      );
  }

  /**
   * Calculate Top 10 and Least 10 Operated ULBs from ULB Trips Data
   * Sorts by operated percentage and takes top 10 and least 10
   */
  calculateTop10OperatedUlbs(): void {
    if (this.ulbTripsDta && this.ulbTripsDta.length > 0) {
      // Filter valid entries with operated percentage
      const validData = [...this.ulbTripsDta].filter(
        (ulb) => ulb.opper !== null && ulb.opper !== undefined
      );

      // Sort by operated percentage descending for Top 10
      const sortedDescending = [...validData].sort(
        (a, b) => (b.opper || 0) - (a.opper || 0)
      );

      // Top 10 - highest operated percentage
      this.top10OperatedUlbs = sortedDescending
        .slice(0, 10)
        .map((ulb, index) => ({
          sno: index + 1,
          tnt_nm: ulb.tnt_dsply_nm || ulb.tnt_nm,
          tot_veh: ulb.tot_veh || 0,
          operated: ulb.operated || 0,
          notoperated: ulb.notoperated || 0,
          opper: ulb.opper || 0,
        }));

      // Least 10 - lowest operated percentage (sort ascending)
      const sortedAscending = [...validData].sort(
        (a, b) => (a.opper || 0) - (b.opper || 0)
      );
      this.least10OperatedUlbs = sortedAscending
        .slice(0, 10)
        .map((ulb, index) => ({
          sno: index + 1,
          tnt_nm: ulb.tnt_dsply_nm || ulb.tnt_nm,
          tot_veh: ulb.tot_veh || 0,
          operated: ulb.operated || 0,
          notoperated: ulb.notoperated || 0,
          opper: ulb.opper || 0,
        }));

      this.top10OperatedUlbsColumnDefs = [
        { headerName: "Rank", field: "sno", alignment: "center", width: 60 },
        {
          headerName: "ULB Name",
          field: "tnt_nm",
          alignment: "left",
          width: 180,
        },
        {
          headerName: "Total Vehicles",
          field: "tot_veh",
          alignment: "center",
          width: 100,
        },
        {
          headerName: "Operated",
          field: "operated",
          alignment: "center",
          width: 100,
        },
        {
          headerName: "NotOperated",
          field: "notoperated",
          alignment: "center",
          width: 100,
        },
        {
          headerName: "Operated %",
          field: "opper",
          alignment: "center",
          width: 100,
          format: { type: "fixedPoint", precision: 2 },
        },
      ];

      console.log("Top 10 Operated ULBs:", this.top10OperatedUlbs);
      console.log("Least 10 Operated ULBs:", this.least10OperatedUlbs);
    }
  }

  /**
   * Toggle flip state for Top/Least ULBs card
   */
  toggleUlbCard(): void {
    this.isUlbCardFlipped = !this.isUlbCardFlipped;
  }

  /**
   * Set ULB card view directly (top or least)
   */
  setUlbCardView(view: "top" | "least"): void {
    this.isUlbCardFlipped = view === "least";
  }

  /**
   * Create Distance Pie Chart (Vehicles Travelled >= 500m vs < 500m)
   */
  createDistancePieChart(): void {
    // Dispose existing chart if it exists
    if (this.distancePieChart) {
      this.distancePieChart.dispose();
    }

    // Check if container exists
    const container = document.getElementById("distancePieChart");
    if (!container) return;

    // Get data
    if (!this.ttlDstncCnt || this.ttlDstncCnt.length === 0) return;
    const data = this.ttlDstncCnt[0];
    const abv500 = data.urbn_tdydst_abv30 || 0;
    const blw500 = data.urbn_tdydst_blw30 || 0;

    // Create chart
    let chart = am4core.create("distancePieChart", am4charts.PieChart);
    this.distancePieChart = chart;

    // Add data
    chart.data = [
      { category: ">= 500m", value: abv500, color: am4core.color("#22c55e") },
      { category: "< 500m", value: blw500, color: am4core.color("#ef4444") },
    ];

    // Configure chart
    chart.innerRadius = am4core.percent(45);
    chart.radius = am4core.percent(95);

    // Create series
    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "category";
    series.slices.template.propertyFields.fill = "color";
    series.slices.template.stroke = am4core.color("#fff");
    series.slices.template.strokeWidth = 2;
    series.slices.template.strokeOpacity = 1;

    // Add tooltip with percentage
    series.slices.template.tooltipText =
      "{category}: {value} ({value.percent.formatNumber('#.0')}%)";

    // Disable labels and ticks (percentages shown in HTML)
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;

    // Add center label with percentage of >= 500m
    const total = abv500 + blw500;
    const percentage = total > 0 ? ((abv500 / total) * 100).toFixed(0) : 0;
    let label = chart.seriesContainer.createChild(am4core.Label);
    label.text = percentage + "%";
    label.horizontalCenter = "middle";
    label.verticalCenter = "middle";
    label.fontSize = 16;
    label.fontWeight = "bold";
    label.fill = am4core.color("#22c55e");

    // Disable legend
    chart.legend = undefined;
  }

  /**
   * Create Working Hours Pie Chart (>= 30 min vs < 30 min)
   */
  createWorkingHoursPieChart(): void {
    // Dispose existing chart if it exists
    if (this.workingHoursPieChart) {
      this.workingHoursPieChart.dispose();
    }

    // Check if container exists
    const container = document.getElementById("workingHoursPieChart");
    if (!container) return;

    // Get data
    if (!this.tdyCoveredTrips || this.tdyCoveredTrips.length === 0) return;
    const data = this.tdyCoveredTrips[0];
    const abv30 = data.abv_30_wrkd_tm_ct || 0;
    const blw30 = data.blw_30_wrkd_tm_ct || 0;

    // Create chart
    let chart = am4core.create("workingHoursPieChart", am4charts.PieChart);
    this.workingHoursPieChart = chart;

    // Add data
    chart.data = [
      { category: ">= 30 min", value: abv30, color: am4core.color("#22c55e") },
      { category: "< 30 min", value: blw30, color: am4core.color("#ef4444") },
    ];

    // Configure chart
    chart.innerRadius = am4core.percent(45);
    chart.radius = am4core.percent(95);

    // Create series
    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "category";
    series.slices.template.propertyFields.fill = "color";
    series.slices.template.stroke = am4core.color("#fff");
    series.slices.template.strokeWidth = 2;
    series.slices.template.strokeOpacity = 1;

    // Add tooltip with percentage
    series.slices.template.tooltipText =
      "{category}: {value} ({value.percent.formatNumber('#.0')}%)";

    // Disable labels and ticks (percentages shown in HTML)
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;

    // Add center label with percentage of >= 30 min
    const total = abv30 + blw30;
    const percentage = total > 0 ? ((abv30 / total) * 100).toFixed(0) : 0;
    let label = chart.seriesContainer.createChild(am4core.Label);
    label.text = percentage + "%";
    label.horizontalCenter = "middle";
    label.verticalCenter = "middle";
    label.fontSize = 16;
    label.fontWeight = "bold";
    label.fill = am4core.color("#22c55e");

    // Disable legend
    chart.legend = undefined;
  }

  /**
   * Initialize both pie charts
   */
  initPieCharts(): void {
    setTimeout(() => {
      this.createDistancePieChart();
      this.createWorkingHoursPieChart();
    }, 500);
  }

  getWeeklyOperationalStatusData(): void {
    // Dispose existing chart if it exists
    if (this.chart5) {
      this.chart5.dispose();
    }

    let chart = am4core.create(
      "weeklyOperationalStatusChart",
      am4charts.XYChart
    );
    this.chart5 = chart;
    chart.data = [];

    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 0,
      slctd_tnt: 0,
    };

    let rte = `dashboard/enterprise/get_last7daydata/${this.dbrd_ky}`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200 && res["data"] && res["data"].length > 0) {
          chart.data = res["data"];

          let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis.dataFields.category = "dt";
          categoryAxis.renderer.grid.template.location = 0;
          categoryAxis.renderer.minGridDistance = 30;
          categoryAxis.title.text = `Date (${this.curYr})`;
          categoryAxis.renderer.labels.template.rotation = 0;

          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          valueAxis.title.text = "Number of Vehicles";

          chart.colors.list = [
            am4core.color("#10b981"),
            am4core.color("#ef4444"),
          ];

          function createSeries(field: string, name: string, color: string) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "dt";
            series.name = name;
            series.columns.template.tooltipText =
              "{name} on {categoryX}: [bold]{valueY} Vehicles[/]";
            series.columns.template.fillOpacity = 0.8;
            series.columns.template.fill = am4core.color(color);
            series.columns.template.stroke = am4core.color(color);
            series.columns.template.height = am4core.percent(100);

            let columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 1;
            columnTemplate.column.cornerRadiusTopLeft = 5;
            columnTemplate.column.cornerRadiusTopRight = 5;
            columnTemplate.strokeOpacity = 1;

            let valueLabel = series.bullets.push(new am4charts.LabelBullet());
            valueLabel.label.text = "{valueY}";
            valueLabel.label.fontSize = 12;
            valueLabel.label.dy = -10;

            return series;
          }

          // Create series for operational status
          createSeries("oprtd", "Operated", "#10b981");
          createSeries("nt_optrd", "Not Operated", "#ef4444");

          chart.legend = new am4charts.Legend();
          chart.legend.position = "bottom";
        }
      },
      (err) => {
        console.log("Error loading weekly operational status data:", err);
      }
    );
  }

  // Format currency value with Indian locale (₹1,23,456)
  formatCurrency(value: number): string {
    if (value === null || value === undefined || isNaN(value)) {
      return "₹0";
    }
    return this.currencyFormatter.format(value);
  }

  // Format number with Indian locale (1,23,456)
  formatNumber(value: number): string {
    if (value === null || value === undefined || isNaN(value)) {
      return "0";
    }
    return this.numberFormatter.format(value);
  }

  // Navigate to respective page from card arrow
  navigateToPage(path: string) {
    this.TransfereService.setLoclData("from_urban_dashboard", true);
    this.route.navigate([`internal/${path}`]);
  }
}
